/**
 * This file gets autogenerated from the command line by running:
 * "npm run build:panenka-icons"
 *
 * ⚠️ Please do not modify it manually, always use 'npm run build:panenka-icons'
 * and commit any change resulted after running the build command.
 *
 */

export const ICONS_SET = [
  'actions-add-circle',
  'actions-add-to-calendar',
  'actions-add',
  'actions-check-circle',
  'actions-check',
  'actions-compare',
  'actions-copy',
  'actions-delete',
  'actions-directions',
  'actions-dislike-filled',
  'actions-dislike',
  'actions-download',
  'actions-edit-filled',
  'actions-edit',
  'actions-equal-alt',
  'actions-equal',
  'actions-expand-all',
  'actions-favourite-active',
  'actions-favourite',
  'actions-filter-circle-filled',
  'actions-filter-circle',
  'actions-filter',
  'actions-followed-active',
  'actions-followed',
  'actions-language',
  'actions-like-filled',
  'actions-like',
  'actions-map',
  'actions-microphone',
  'actions-open-in-full',
  'actions-print',
  'actions-profile',
  'actions-remove',
  'actions-restart',
  'actions-save',
  'actions-scan',
  'actions-search',
  'actions-settings',
  'actions-share-android',
  'actions-share-ios',
  'actions-sorting',
  'av-airplay',
  'av-backward',
  'av-chromecast',
  'av-forward-10',
  'av-forward',
  'av-fullscreen',
  'av-pause-circle-negative',
  'av-pause-circle',
  'av-pause',
  'av-play-circle-negative',
  'av-play-circle',
  'av-play',
  'av-replay-10',
  'av-sound-down',
  'av-sound-off',
  'av-sound-up',
  'av-sound',
  'av-stop-circle-negative',
  'av-stop',
  'close-web-icon',
  'features-euro-2020',
  'features-event-companion',
  'features-fantasy-and-predictor',
  'features-games',
  'features-gott',
  'features-history',
  'features-hospitality',
  'features-panini-virtual-album',
  'features-player-ranking',
  'features-podcast',
  'features-predictor',
  'features-radio',
  'features-simulator-tool-standings-alt',
  'features-skills',
  'features-star-of-the-match',
  'features-stats',
  'features-store',
  'features-teams',
  'features-tickets',
  'features-top-scorer',
  'features-tournament-predictor',
  'features-uefa-tv',
  'features-unl',
  'features-w2021',
  'football-card-single-card',
  'football-card-yellow-to-red-color',
  'football-doubtful-injured',
  'football-eliminated',
  'football-goal-extra-time-color',
  'football-goal-penalty-color',
  'football-goal-penalty-missed-color',
  'football-goal',
  'football-penalty-goal',
  'football-penalty-out',
  'football-penalty-shootout',
  'football-substitution-both-color',
  'football-substitution-in',
  'football-substitution-out',
  'football-suspended',
  'football-time-additional-time-color',
  'football-time-break',
  'football-time-end-color',
  'football-time-extra-time-color',
  'football-time-resume',
  'football-time-start',
  'football-time-wistle',
  'football-var',
  'gaming-auto-complete',
  'gaming-bench',
  'gaming-captain',
  'gaming-fantasy-5-my-picks',
  'gaming-friends',
  'gaming-league-invite',
  'gaming-league',
  'gaming-leagues',
  'gaming-limitless',
  'gaming-loading',
  'gaming-recommended',
  'gaming-recover',
  'gaming-sub-in',
  'gaming-sub-out',
  'gaming-substitution',
  'gaming-team',
  'gaming-transfer',
  'gaming-unlimited',
  'gaming-wildcard',
  'goal-product-icon',
  'head-product-icon',
  'jersey-captain-product-icon',
  'jersey-product-icon',
  'left-foot-product-icon',
  'navigation-arrow-down-circle',
  'navigation-arrow-left-circle',
  'navigation-arrow-right-circle',
  'navigation-arrow-up-circle',
  'navigation-back-android',
  'navigation-back-ios',
  'navigation-chevron-down-circle',
  'navigation-chevron-down-xs',
  'navigation-chevron-down',
  'navigation-chevron-left-circle',
  'navigation-chevron-left-xs',
  'navigation-chevron-left',
  'navigation-chevron-right-circle',
  'navigation-chevron-right-xs',
  'navigation-chevron-right',
  'navigation-chevron-up-circle',
  'navigation-chevron-up-xs',
  'navigation-chevron-up',
  'navigation-close',
  'navigation-collapse',
  'navigation-dropdown-indicator',
  'navigation-dropdown-up',
  'navigation-exit',
  'navigation-expand',
  'navigation-leave',
  'navigation-logout',
  'navigation-menu-overflow',
  'navigation-menu',
  'notifications-active',
  'notifications-disabled',
  'notifications-none',
  'notifications-subscribed',
  'own-goal-product-icon',
  'pitch-product-icon',
  'right-foot-product-icon',
  'score-product-icon',
  'shirt-product-icon',
  'social-facebook-circle',
  'social-facebook',
  'social-instagram',
  'social-linkedin',
  'social-tik-tok-circle',
  'social-tik-tok',
  'social-twitter-circle',
  'social-twitter',
  'social-vk-circle',
  'social-vk',
  'social-whatsapp',
  'social-youtube',
  'spectator-activity-contest',
  'spectator-area',
  'spectator-basic-info-negative',
  'spectator-basic-info',
  'spectator-before-you-book',
  'spectator-city-events',
  'spectator-concert-alt',
  'spectator-concert',
  'spectator-draw',
  'spectator-event',
  'spectator-fan-march',
  'spectator-fan-meeting-point-negative',
  'spectator-fan-meeting-point',
  'spectator-fan-zone-negative',
  'spectator-fan-zone',
  'spectator-football-village-negative',
  'spectator-football-village',
  'spectator-getting-there',
  'spectator-misc',
  'spectator-parking',
  'spectator-service-point',
  'spectator-special',
  'spectator-spectacular',
  'spectator-sponsor-activations-negative',
  'spectator-sponsor-activations',
  'spectator-stadium entrance',
  'spectator-stadium-alt',
  'spectator-stadium-negative',
  'spectator-stadium-rules',
  'spectator-stadium',
  'spectator-transport',
  'support-accessibility',
  'support-alert',
  'support-broadcaster',
  'support-calendar',
  'support-commentary',
  'support-external',
  'support-image',
  'support-information',
  'support-jersey-star-filled',
  'support-jersey-star-outlined',
  'support-lock-closed-filled',
  'support-lock-closed',
  'support-lock-open',
  'support-mail',
  'support-phone',
  'support-question-mark-filled',
  'support-question-mark',
  'support-rotate-device',
  'support-time',
  'support-today',
  'support-trophy',
  'support-url',
  'support-video-lock-closed-filled',
  'support-visibility-off',
  'support-visibility-on',
  'support-warning',
  'tab-bar-fantasy-active',
  'tab-bar-fantasy',
  'tab-bar-home-active',
  'tab-bar-home',
  'tab-bar-matches-active',
  'tab-bar-matches',
  'tab-bar-more-active',
  'tab-bar-more',
  'tab-bar-standings-active',
  'tab-bar-standings',
  'tab-bar-teams-active',
  'tab-bar-teams',
  'tab-bar-ucl-fantasy-active',
  'tab-bar-ucl-fantasy',
  'tab-bar-your-clubs-active',
  'tab-bar-your-clubs',
  'transport-accommodation',
  'transport-airport',
  'transport-bag',
  'transport-car',
  'transport-cycling',
  'transport-dot',
  'transport-flight-take-off',
  'transport-layers-filled',
  'transport-layers',
  'transport-metro',
  'transport-my-location',
  'transport-near-me-filled',
  'transport-near-me',
  'transport-origin',
  'transport-pin',
  'transport-restaurant',
  'transport-rideshare',
  'transport-travel',
  'transport-walking',
  'trophy-euro-product-icon',
  'trophy-fin-product-icon',
  'trophy-scup-line-product-icon',
  'trophy-scup-product-icon',
  'trophy-ucl-line-product-icon',
  'trophy-ucl-product-icon',
  'trophy-uecl-line-product-icon',
  'trophy-uecl-product-icon',
  'trophy-uel-line-product-icon',
  'trophy-uel-product-icon',
  'trophy-unl-line-product-icon',
  'trophy-uwcl-product-icon',
  'trophy-weuro-product-icon',
  'trophy-wfin-product-icon',
  'weather-clear-night',
  'weather-cloudy-night-alt',
  'weather-cloudy-night',
  'weather-cloudy',
  'weather-foggy-single',
  'weather-foggy',
  'weather-hail',
  'weather-partly-cloudy-alt',
  'weather-partly-cloudy-night',
  'weather-partly-cloudy',
  'weather-rain-single',
  'weather-rain',
  'weather-snow-single',
  'weather-snow',
  'weather-stormy-single',
  'weather-stormy',
  'weather-sunny',
  'weather-windy',
];
